import { Component, input } from '@angular/core';

@Component({
  selector: 'app-identity',
  template: `
    <div class="identity-wrapper">
      @if (twitterHandle()) {
      <div class="identity-handle">{{ '@' + twitterHandle() }}</div>
      @if (! hideTwitterLink()) {
      <div class="identity-x-wrapper">
        <a
          class="identity-x-mark"
          [href]="'https://x.com/' + twitterHandle()"
          target="_blank"
          rel="noopener noreferrer"
          [attr.aria-label]="'View @' + twitterHandle() + ' on X'"
          (click)="$event.stopPropagation()"
          >𝕏</a
        >
      </div>
      } } @else if (username()) {
      <span class="identity-username">{{ username() }}</span>
      } @else {
      <span class="identity-fallback">{{ fallback() }}</span>
      }
    </div>
  `,
  styles: [
    `
      :host {
        display: inline;
      }
      .identity-wrapper {
        display: flex;
        align-items: center;
      }
      .identity-x-wrapper {
        margin-bottom: 4px;
      }
      .identity-x-mark {
        /* Better VCR's U+1D54F is malformed; JetBrains Mono has a clean 𝕏. */
        font-family: var(--font-mono);
        color: var(--text-primary);
        margin-left: 0.3rem;
        text-decoration: none;
        cursor: pointer;
      }
      .identity-x-mark:hover {
        text-decoration: underline;
        text-underline-offset: 2px;
      }
      .identity-fallback {
        color: var(--text-muted, #777b79);
      }
    `,
  ],
})
export class IdentityComponent {
  readonly username = input<string | null>(null);
  readonly twitterHandle = input<string | null>(null);
  readonly fallback = input<string>('Anon');
  readonly hideTwitterLink = input<boolean>(false);
}
